import { Navigate, Outlet, useLocation } from 'react-router';
import useAuthStore from '../../stores/authStore.js';
import AuthPending from './AuthPending.jsx';
import NotFoundPage from '../../pages/NotFoundPage.jsx';

/**
 * Pathless layout guard for /admin.
 *
 * A signed-out visitor is sent to sign in. A signed-in customer gets the 404
 * page rather than a "forbidden" — there is no reason to confirm to a random
 * account that an admin panel lives at this URL.
 *
 * The real protection is server-side: every /admin/* API route re-checks the
 * role on the token. Editing `role` in this store changes the navigation and
 * nothing else.
 */
export default function RequireAdmin() {
  const status = useAuthStore((s) => s.status);
  const role = useAuthStore((s) => s.user?.role);
  const location = useLocation();

  if (status === 'unknown') return <AuthPending />;

  if (status !== 'authenticated') {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  if (role !== 'admin') return <NotFoundPage />;

  return <Outlet />;
}
